module.exports = __webpack_public_path__ + "static/media/797ea583.jpg";